<template>
    <ProgressSpinner v-if="!transfer"/>
    <Container class="pt-6" v-if="transfer">
        <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
            <PageHeading>{{ transfer.asset?.name ?? $route.params.transfer }}</PageHeading>
        </div>

	    <div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
        <TabLayout :tabs="tabs" sticky/>
	    </div>

        <router-view
		        @on-save="$emit('on-save')"
		        @on-delete="$emit('on-delete')"
		        :transfer="transfer"
        ></router-view>
    </Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useAssetTransfersStore } from "@/stores/assetTransfers.js";
import Container from "@/Components/Container.vue";


export default {
    name: "AssetTransferView",
    components: {Container, TabLayout, PageHeading},
    data() {
        return {
            transfer: undefined,
        }
    },
    emits: [
        'on-save',
		    'on-delete',
    ],
    watch: {
        '$route.params.transfer': {
            async handler(newValue) {
                if (newValue) {
                    if (this.$route.params.transfer === 'NEW') {
                        this.transfer = {};
                    } else {
                        this.transfer = await this.assetTransfersStore.showAssetTransfer(
                          this.$route.params.transfer,
                          { include: 'asset,preOwner,currentOwner,asset.devices,asset.devices.deviceType', }
                        );
                    }
                } else {
                    this.transfer = undefined;
                }
            },
            immediate: true,
        }
    },
    computed: {
        ...mapStores(useAssetTransfersStore),
        tabs() {
            return [
                {
                    label: this.$t('common.properties'),
                    current: this.$route.name === 'admin.assets.transfers.transfer',
                    to: {name: 'admin.assets.transfers.transfer', params: this.$route.params}
                },
            ]
        }
    },
}
</script>
